import { supabaseData } from './supabaseData';

let lastCaptureTime = 0;
const MIN_CAPTURE_INTERVAL = 60000; // Don't capture more than once per minute

export async function captureLocation(userId, companyId, eventType) {
  if (!userId || !companyId) return;

  // Throttle captures
  const now = Date.now();
  if (now - lastCaptureTime < MIN_CAPTURE_INTERVAL && eventType === 'app_open') return;

  if (!navigator.geolocation) return;

  try {
    const position = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: false,
        timeout: 10000,
        maximumAge: 300000, // 5 min cache OK
      });
    });

    const { latitude, longitude, accuracy } = position.coords;

    // Upsert: one row per user per company, always update
    const { error } = await supabaseData
      .from('tech_locations')
      .upsert({
        user_id: userId,
        company_id: companyId,
        latitude,
        longitude,
        accuracy,
        event_type: eventType,
        updated_at: new Date().toISOString(),
      }, {
        onConflict: 'user_id,company_id',
      });

    if (error) {
      // If upsert fails (no unique constraint yet), try insert
      if (error.code === '42P10' || error.message?.includes('unique')) {
        await supabaseData.from('tech_locations').insert({
          user_id: userId,
          company_id: companyId,
          latitude,
          longitude,
          accuracy,
          event_type: eventType,
        });
      }
    }

    lastCaptureTime = now;
  } catch {
    // Silently fail - location denied or unavailable is fine
  }
}
